import { FETCH_SITE_CAPACITIES } from 'actions';

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_SITE_CAPACITIES:
            return action.payload;
        default:
            return state;
    }
};
